import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import ProductSelectAsync from "../product/ProductSelectAsync";
import {
    downloadDeliveryStatement, downloadDeliveryStatementByDate,
    getProductById,
    getRentalById,
} from "../../utils/requestUtils";
import Config from "../../core/config";
import {
    calculateDaysDifference,
    formatDateString,
    formatDateToAmericanFormat,
    formatDateToString, parseLocalDate, removeTimeFromDate
} from "../../utils/utils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {saveAs} from 'file-saver';

import DatePicker from "react-datepicker";
import WhatsAppButton from "../../core/WhatsAppButton";
import TimePeriodPicker from "../customer/TimePeriodPicker";
import {formatTime} from "../../core/date";
import SearchButton from '../common/SearchButton';
import TableRowActions from '../common/TableRowActions';
import ListPageLayout from '../common/ListPageLayout';
import ActionIconButton from '../common/ActionIconButton';
import {useReactToPrint} from "react-to-print";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import CustomerViewer from "../customer/CustomerViewer";
import ModalDiv from "../../ModalDiv";
import {useNavigate, useLocation} from "react-router-dom";
import {usePermission} from "../../core/PermissionContext";
import {UserPermission} from "../../utils/utils";

const apiUrl = Config.apiUrl;
const ProductRentedListToDeliverReturn = (props) => {
    const {delivered, onRequestExtendRent} = props;
    const navigate = useNavigate();
    const location = useLocation();
    const {hasUserPermission} = usePermission();
    
    const handleRequestExtendRent = (rental, rentalItems, deliveryDate) => {
        if (onRequestExtendRent) {
            onRequestExtendRent(rental, rentalItems, deliveryDate);
        } else {
            // Navigate to RentalManager with rental data
            const rentalItemsParam = JSON.stringify(rentalItems);
            const url = `/app/rental?rentalId=${rental.id}&rentalItems=${encodeURIComponent(rentalItemsParam)}&date=${encodeURIComponent(deliveryDate)}`;
            navigate(url);
        }
    };
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState(undefined);

    const [showCustomerViewer, setShowCustomerViewer] = useState(false);
    const [customerViewerId, setCustomerViewerId] = useState(undefined);
    const [showTimePeriodPicker, setShowTimePeriodPicker] = useState(false);
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [deliveryStatus, setDeliveryStatus] = useState(0);
    const [indexItemChangingTime, setIndexItemChangingTime] = useState(-1);
    const [startTimePeriodChanging, setStartTimePeriodChanging] = useState(undefined);
    const [endTimePeriodChanging, setEndTimePeriodChanging] = useState(undefined);
    const [expandedRows, setExpandedRows] = useState(new Set());

    const toggleRow = (key) => {
        setExpandedRows(prev => {
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };

    async function makeQuery(startDate_, endDate_, deliveryStatus) {
        try {
            setLoading(true);
            if (delivered && deliveryStatus === 2 && (!startDate_ || !endDate_)) {
                alert('Para consultar itens devolvidos, informe o período.');
                return;
            }

            const newStartDate = startDate_ ? startDate_ : new Date(1900, 0, 1);
            const newEndDate = endDate_ ? endDate_ : new Date(2100, 0, 1);
            const deliveryStatusList = deliveryStatus === 1 ? [0, 1] : [deliveryStatus];
            const url = `${apiUrl}/api/productRented/findRentals?startDate=${formatDateToAmericanFormat(newStartDate)}&endDate=${formatDateToAmericanFormat(newEndDate)}&status=${-1}&productId=${product ? product.id : 0}&deliveryStatus=${deliveryStatusList.join(',')}&delivered=${delivered}`;
            const rentals = await makeRequest(url, 'GET');
            // rentals.map((r) => {
            //     r.rentalItems.map((ri) => {
            //         products = [...products, {rental: r, rentalItem: ri}]
            //     })
            // });

            const products = rentals.reduce((acc, rental) => {
                rental.rentalItems.forEach((ri) => {
                    const date = delivered ? ri.returnDate : ri.rentalDate;
                    const key = `${rental.id}-${date}`;

                    const startTime = delivered ? ri.returnStartTime : ri.deliveryStartTime;
                    const endTime = delivered ? ri.returnEndTime : ri.deliveryEndTime;

                    if (!acc[key]) {
                        acc[key] = {
                            rental: rental,
                            rentalItems: [],
                            date: date,
                            startTime: startTime,
                            endTime: endTime,
                        };
                    }

                    acc[key].rentalItems.push(ri);
                });

                return acc;
            }, {});

            const sortedProducts = Object.values(products).sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);

                if (dateA - dateB !== 0) {
                    return dateA - dateB;
                } else if (a.startTime !== b.startTime) {
                    return a.startTime < b.startTime ? -1 : 1;
                } else {
                    return a.endTime < b.endTime ? -1 : 1;
                }
            });
            setProducts(sortedProducts);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        setEndDate(tomorrow);
        setStartDate(undefined);
        const deliveryStatus = delivered ? 1 : 0;
        setDeliveryStatus(deliveryStatus);
        makeQuery(undefined, tomorrow, deliveryStatus);
    }, []);

    useEffect(() => {
        const deliveryStatus = delivered ? 1 : 0;
        setDeliveryStatus(deliveryStatus);
        if(endDate) {
            makeQuery(startDate, endDate, deliveryStatus)
        }
    }, [delivered]);

    // Refresh component when URL changes
    useEffect(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        setEndDate(tomorrow);
        setStartDate(undefined);
        setProduct(undefined);
        setProducts([]);
        const deliveryStatus = delivered ? 1 : 0;
        setDeliveryStatus(deliveryStatus);
        makeQuery(undefined, tomorrow, deliveryStatus);
    }, [location.pathname, delivered]);
    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };
    //
    // const handleInputChange = (e) => {
    //     const string = e.target.value;
    //     if (string.length >= 3 || string.length === 0) {
    //         makeQuery(string);
    //     }
    //     setQueryString(string);
    // };

    async function onFinishClick(rentalItems) {
        setLoading(true);
        if (delivered) {
            const finish = deliveryStatus === 1;
            if (!window.confirm(finish ? 'Deseja realmente baixar?' : 'Deseja realmente estornar a devolucão?')) {
                return;
            }
            for (let i = 0; i < rentalItems.length; i++) {
                const rentalItem = rentalItems[i];

                const url = apiUrl + '/api/rentalItem/' + (finish ? 'finishRentalItems' : 'reverseReturnedRentalItems') + '?id=' + rentalItem.id;
                await makeRequest(url, 'PUT', {
                    'Content-Type': 'application/json',
                });
            }
        } else {
            const deliver = deliveryStatus === 0;
            if (!window.confirm(deliver ? 'Deseja realmente entregar?' : 'Deseja realmente estornar a entrega?')) {
                return;
            }
            for (let i = 0; i < rentalItems.length; i++) {
                const rentalItem = rentalItems[i];

                const url = apiUrl + '/api/rentalItem/' + (deliver ? 'deliverRentalItems' : 'reverseDeliveredRentalItems') + '?id=' + rentalItem.id;
                await makeRequest(url, 'PUT', {
                    'Content-Type': 'application/json',
                });
            }
        }
        setLoading(false);

        await makeQuery(startDate, endDate, deliveryStatus);
    }


    async function selectProduct(id) {
        const product = await getProductById(id);
        setProduct(product);
    }

    const handleProductItemClick = async (id) => {
        await selectProduct(id);
    };

    const changeTimePeriod = async (startTime, endTime) => {
        const rentalTemp = await getRentalById(products[indexItemChangingTime].rental.id);
        if (delivered) {
            for (let i = 0; i < rentalTemp.rentalItems.length; i++) {
                const rentalItem = rentalTemp.rentalItems[i];
                const url = apiUrl + '/api/rentalItem/return-period?rentalId=' + rentalTemp.id + '&date=' + rentalItem.returnDate + '&returnStartTime=' + startTime + ':00' + '&returnEndTime=' + endTime + ':00';
                await makeRequest(url, 'PUT', {
                    'Content-Type': 'application/json',
                });
            }
        } else {

            for (let i = 0; i < rentalTemp.rentalItems.length; i++) {
                const rentalItem = rentalTemp.rentalItems[i];

                const url = apiUrl + '/api/rentalItem/delivery-period?rentalId=' + rentalTemp.id + '&date=' + rentalItem.rentalDate + '&deliveryStartTime=' + startTime + ':00' + '&deliveryEndTime=' + endTime + ':00';
                await makeRequest(url, 'PUT', {
                    'Content-Type': 'application/json',
                });
            }
        }

        await makeQuery(startDate, endDate, deliveryStatus);
        setShowTimePeriodPicker(false);
    };



    const componentRef = useRef();

    function getBackgroundColor(item) {
        const currentDate = removeTimeFromDate(new Date());
        const rentalDate = parseLocalDate(item.date);
        const returnDate = parseLocalDate(item.date);
        const errorColor = 'var(--error-color)';
        const warningColor = 'var(--warning-color)';
        const normalColor = undefined;
        if (delivered) {
            if (returnDate < currentDate)
                return errorColor;
            if (calculateDaysDifference(returnDate, currentDate) === 0) {
                return warningColor;
            }
        } else {
            if (rentalDate < currentDate)
                return errorColor;
            if (calculateDaysDifference(rentalDate, currentDate) === 0) {
                return warningColor;
            }
        }

        return normalColor;
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Relatório de ' + (delivered ? 'Devoluções' : 'Entregas'),
        pageStyle: `
      @page {
        size: A4;
        margin: 20mm !important;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
        }
        div, table, thead, tbody, tfoot, tr, th, td {
          overflow: visible !important;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px solid black;
          padding: 5px;
        }
        tbody {
          display: table-row-group;
        }
        .print-button {
          display: none;
        }
      }
    `,
    });

    function handleCustomerViewClick(id) {
        setShowCustomerViewer(true);
        setCustomerViewerId(id);

    }

    const closeCustomerViewer = () => {
        console.log("closeCustomerViewer called");
        setShowCustomerViewer(false);
        setCustomerViewerId(undefined);
    };

    const formatRentalAddress = (rental) => {
        let address = rental.address || '';
        if (rental.addressNumber !== null && rental.addressNumber > 0) {
            address += ', ' + rental.addressNumber;
        }
        if (rental.addressComplement) {
            address += ' - ' + rental.addressComplement;
        }
        address += ' - ' + rental.neighborhood;
        return address;
    };

    const getMapsAddress = (rental) => ({
        address: rental.address + (rental.addressNumber !== null && rental.addressNumber > 0 ? ', ' + rental.addressNumber : '') + ' - ' + rental.neighborhood,
        city: rental.city + ' - ' + rental.state,
        cep: rental.cep,
    });

    const getFinishButtonLabel = (item) => {
        if (delivered && item.rentalItems.find((ri) => ri.deliveryStatus === 0 || ri.deliveryStatus === 1)) {
            return 'Devolver';
        }
        if (!delivered && item.rentalItems.find((ri) => ri.deliveryStatus === 0)) {
            return 'Entregar';
        }
        return 'Estornar';
    };

    const openTimePeriodPicker = (item, index) => {
        setStartTimePeriodChanging(item.startTime ? formatTime(item.startTime) : '');
        setEndTimePeriodChanging(item.endTime ? formatTime(item.endTime) : '');
        setIndexItemChangingTime(index);
        setShowTimePeriodPicker(true);
    };

    const buildDeliveryRowActions = (item, index) => {
        const finishLabel = getFinishButtonLabel(item);
        const finishDisabled = delivered && item.rentalItems.find((ri) => !ri.delivered);
        const mapsAddress = getMapsAddress(item.rental);
        const actions = [
            {
                key: 'view-customer',
                label: 'Ver cliente',
                visible: hasUserPermission(UserPermission.DELIVERY_CONTROL_VIEW_CUSTOMER),
                onClick: () => handleCustomerViewClick(item.rental.customer.id),
                render: () => (
                    <ActionIconButton
                        variant="view"
                        title="Ver cliente"
                        onClick={() => handleCustomerViewClick(item.rental.customer.id)}
                    />
                ),
            },
            {
                key: 'whatsapp',
                label: 'WhatsApp',
                visible: !!item.rental.customer.phone && hasUserPermission(UserPermission.DELIVERY_CONTROL_WHATSAPP),
                phoneNumber: item.rental.customer.phone,
                personName: item.rental.customer.name,
                render: () => (
                    <WhatsAppButton
                        phoneNumber={item.rental.customer.phone}
                        personName={item.rental.customer.name}
                    />
                ),
            },
            {
                key: 'maps',
                label: 'Google Maps',
                onClick: () => {
                    const formattedAddress = encodeURIComponent(`${mapsAddress.address}, ${mapsAddress.city}, ${mapsAddress.cep}`);
                    window.open('https://www.google.com/maps?q=' + formattedAddress, '_blank');
                },
                render: () => (
                    <ActionIconButton
                        variant="maps"
                        title="Google Maps"
                        onClick={() => {
                            const formattedAddress = encodeURIComponent(`${mapsAddress.address}, ${mapsAddress.city}, ${mapsAddress.cep}`);
                            window.open('https://www.google.com/maps?q=' + formattedAddress, '_blank');
                        }}
                    />
                ),
            },
            {
                key: 'time',
                label: 'Alterar horário',
                visible: hasUserPermission(UserPermission.DELIVERY_CONTROL_CHANGE_TIME),
                onClick: () => openTimePeriodPicker(item, index),
                render: () => (
                    <ActionIconButton
                        variant="time"
                        title="Alterar horário"
                        onClick={() => openTimePeriodPicker(item, index)}
                    />
                ),
            },
            {
                key: 'finish',
                label: finishLabel,
                type: finishLabel === 'Entregar' ? 'confirm' : 'reverse',
                visible: hasUserPermission(UserPermission.DELIVERY_CONTROL_FINISH),
                disabled: finishDisabled,
                onClick: () => onFinishClick(item.rentalItems),
                buttonProps: {className: 'finish-button'},
                render: () => (
                    <button
                        className="finish-button"
                        name="finish-button"
                        data-test="finish-button"
                        disabled={finishDisabled}
                        onClick={() => onFinishClick(item.rentalItems)}
                    >
                        {finishLabel}
                    </button>
                ),
            },
        ];

        if (delivered) {
            actions.push({
                key: 'extend',
                label: 'Prorrogar',
                visible: hasUserPermission(UserPermission.DELIVERY_CONTROL_EXTEND),
                disabled: finishDisabled,
                onClick: () => {
                    const rentalItems = item.rentalItems.map(ri => ({
                        rentalId: item.rental.id,
                        productId: ri.product.id,
                        quantity: ri.quantity,
                        rentalDays: ri.rentalDays,
                        rentalDate: ri.rentalDate,
                        returnDate: ri.returnDate,
                    }));
                    handleRequestExtendRent(item.rental, rentalItems, item.date);
                },
                render: () => (
                    <ActionIconButton
                        variant="extend"
                        title="Prorrogar"
                        disabled={finishDisabled}
                        onClick={() => {
                            const rentalItems = item.rentalItems.map(ri => ({
                                rentalId: item.rental.id,
                                productId: ri.product.id,
                                quantity: ri.quantity,
                                rentalDays: ri.rentalDays,
                                rentalDate: ri.rentalDate,
                                returnDate: ri.returnDate,
                            }));
                            handleRequestExtendRent(item.rental, rentalItems, item.date);
                        }}
                    />
                ),
            });
        } else {
            actions.push({
                key: 'term',
                label: 'Termo',
                visible: hasUserPermission(UserPermission.DOWNLOAD_RENTAL_DELIVERY_STATEMENT),
                onClick: () => downloadDeliveryStatementByDate(item.rental.id, item.rental.code, parseLocalDate(item.date)),
                render: () => (
                    <ActionIconButton
                        variant="term"
                        title="Termo"
                        onClick={() => downloadDeliveryStatementByDate(item.rental.id, item.rental.code, parseLocalDate(item.date))}
                    />
                ),
            });
        }

        return actions;
    };

    return (
        <>
            {showCustomerViewer && (
                <CustomerViewer id={customerViewerId} onClose={closeCustomerViewer}/>
            )}

            {showTimePeriodPicker && (
                <TimePeriodPicker
                    startTime={startTimePeriodChanging}
                    endTime={endTimePeriodChanging}
                    onConfirm={changeTimePeriod}
                    onClose={() => setShowTimePeriodPicker(false)}
                />)}
            <div ref={componentRef} className="delivery-control-print-wrapper">
            <ListPageLayout
                tableWidth={900}
                header={
                    <div className="header-label">{delivered ? 'Controle de Devoluções' : 'Controle de Entregas'}</div>
                }
                filters={
                    <div className="list-page-filters-delivery-fields" style={{display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', width: '100%'}}>
                        <div className="list-page-filters-field">
                            <div>Produto:</div>
                            <div className="list-page-filters-field-row" style={{marginTop: '5px'}}>
                                <ProductSelectAsync
                                    onItemClick={handleProductItemClick}
                                    style={{width: '100%'}}
                                    placeholder="Selecione um produto..."
                                    value={product && product.id ? product.id : null}
                                    prefilledProduct={product && product.id ? product : null}
                                />
                                {product && (
                                    <button className="clean-button" onClick={() => setProduct(undefined)}>Limpar</button>
                                )}
                            </div>
                        </div>
                        <div className="list-page-filters-field">
                            <div>{delivered ? 'Data Devolução:' : 'Data Entrega:'}</div>
                            <div className="list-page-filters-period" style={{marginTop: '5px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px'}}>

                            <DatePicker
                                name="startDate"
                                selected={startDate}
                                onChange={handleStartDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                                className="datepicker"
                            />
                            <span className="list-page-filters-period-separator">até</span>
                            <DatePicker
                                name="endDate"
                                selected={endDate}
                                onChange={handleEndDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                                className="datepicker"
                            />
                            <select
                                value={deliveryStatus}
                                data-test="delivery-status-select"
                                onChange={(e) => setDeliveryStatus(parseInt(e.target.value, 10))}
                            >
                                {!delivered && <option key={0} value={0}>A Entregar</option>}
                                <option key={1} value={1}>{!delivered ? 'Entregue' : 'A Devolver'}</option>
                                {delivered && <option key={2} value={2}>Devolvido</option>}
                            </select>
                            <SearchButton title="Consultar" onClick={() => makeQuery(startDate, endDate, deliveryStatus)}/>
                            </div>
                        </div>
                    </div>
                }
                footer={
                    <ActionButtonsManagerView>
                        <button className="print-button" onClick={handlePrint}>Imprimir</button>
                    </ActionButtonsManagerView>
                }
            >
            <div className="list-page-delivery-control">
            <table className="list-page-delivery-control__table">
                <thead>
                <tr>
                    <th className="delivery-col--optional">Código</th>
                    <th className="delivery-col--desktop-only">Cliente</th>
                    <th className="delivery-col--desktop-only"/>
                    <th className="delivery-col--desktop-only"/>
                    <th className="delivery-col--essential">Cliente/Endereço</th>
                    <th className="delivery-col--desktop-only"/>
                    <th className="delivery-col--items">Itens</th>
                    <th className="delivery-col--essential">{delivered ? 'Devolução' : 'Entrega'}</th>
                    <th className="delivery-col--desktop-only"/>
                    <th className="delivery-col--desktop-only"/>
                    <th className="delivery-col--actions delivery-col--mobile-only"/>
                </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                {products.map((item, index) => (
                    <React.Fragment key={`${item.rental.id}-${index}`}>
                    <tr style={{backgroundColor: getBackgroundColor(item)}}>
                    <td className="delivery-col--optional">
                        <div name="rental-code" data-test="rental-code">{item.rental.code}</div>
                    </td>
                    <td className="delivery-col--desktop-only">
                        <div name="customer-name" data-test="customer-name">{item.rental.customer.name}</div>
                    </td>
                    <td className="delivery-col--desktop-only">
                        {hasUserPermission(UserPermission.DELIVERY_CONTROL_VIEW_CUSTOMER) && (
                            <ActionIconButton
                                variant="view"
                                title="Ver cliente"
                                onClick={() => handleCustomerViewClick(item.rental.customer.id)}
                            />
                        )}
                    </td>
                    <td className="delivery-col--desktop-only">
                        {hasUserPermission(UserPermission.DELIVERY_CONTROL_WHATSAPP) && (
                            <WhatsAppButton
                                phoneNumber={item.rental.customer.phone}
                                personName={item.rental.customer.name}
                            />
                        )}
                    </td>
                    <td className="delivery-col--essential">
                        <div className="delivery-customer-name--mobile">{item.rental.customer.name}</div>
                        {!item.rental.deliveryByCompany && (
                            <b>{delivered ? '*Devolução' : '*Retirada'} Cliente*</b>
                        )}
                        <div>{formatRentalAddress(item.rental)}</div>
                    </td>
                    <td className="delivery-col--desktop-only">
                        <ActionIconButton
                            variant="maps"
                            title="Google Maps"
                            onClick={() => {
                                const mapsAddress = getMapsAddress(item.rental);
                                const formattedAddress = encodeURIComponent(`${mapsAddress.address}, ${mapsAddress.city}, ${mapsAddress.cep}`);
                                window.open('https://www.google.com/maps?q=' + formattedAddress, '_blank');
                            }}
                        />
                    </td>
                    <td className="delivery-col--items">
                        {item.rentalItems.map((ri, itemIndex) => (
                            <React.Fragment key={itemIndex}>
                                <b>Item {itemIndex + 1}:</b>{' '}
                                <span name={`rental-item-product-${itemIndex}`} data-test={`rental-item-product-input-${itemIndex}`}>
                                    {ri.product.name}
                                </span>
                                {' '}- Qtd:{' '}
                                <span name={`rental-item-quantity-${itemIndex}`} data-test={`rental-item-quantity-input-${itemIndex}`}>
                                    {ri.quantity}
                                </span>
                                {itemIndex <= item.rentalItems.length - 2 && <br/>}
                            </React.Fragment>
                        ))}
                    </td>
                    <td className="delivery-col--essential">
                        <div style={{textAlign: 'center'}} name="delivery-date" data-test="delivery-date">
                            {formatDateString(item.date)}
                            <br/>
                            <div style={{display: 'flex', fontSize: '10px', padding: '0, 2px', justifyContent: 'center', alignItems: 'center', gap: '4px'}}>
                                {item.startTime ? formatTime(item.startTime) + '-' + formatTime(item.endTime) : ''}
                                {hasUserPermission(UserPermission.DELIVERY_CONTROL_CHANGE_TIME) && (
                                    <span className="delivery-col--desktop-only">
                                        <ActionIconButton
                                            variant="time"
                                            title="Alterar horário"
                                            onClick={() => openTimePeriodPicker(item, index)}
                                        />
                                    </span>
                                )}
                            </div>
                        </div>
                    </td>
                    <td className="delivery-col--desktop-only">
                        {hasUserPermission(UserPermission.DELIVERY_CONTROL_FINISH) && (
                            <button
                                className="finish-button"
                                name="finish-button"
                                data-test="finish-button"
                                disabled={delivered && item.rentalItems.find((ri) => !ri.delivered)}
                                onClick={() => onFinishClick(item.rentalItems)}
                            >
                                {getFinishButtonLabel(item)}
                            </button>
                        )}
                    </td>
                    <td className="delivery-col--desktop-only">
                        {delivered ? (
                            hasUserPermission(UserPermission.DELIVERY_CONTROL_EXTEND) && (
                                <ActionIconButton
                                    variant="extend"
                                    title="Prorrogar"
                                    disabled={delivered && item.rentalItems.find((ri) => !ri.delivered)}
                                    onClick={() => {
                                        const rentalItems = item.rentalItems.map(ri => ({
                                            rentalId: item.rental.id,
                                            productId: ri.product.id,
                                            quantity: ri.quantity,
                                            rentalDays: ri.rentalDays,
                                            rentalDate: ri.rentalDate,
                                            returnDate: ri.returnDate,
                                        }));
                                        handleRequestExtendRent(item.rental, rentalItems, item.date);
                                    }}
                                />
                            )
                        ) : (
                            hasUserPermission(UserPermission.DOWNLOAD_RENTAL_DELIVERY_STATEMENT) && (
                                <ActionIconButton
                                    variant="term"
                                    title="Termo"
                                    onClick={() => downloadDeliveryStatementByDate(item.rental.id, item.rental.code, parseLocalDate(item.date))}
                                />
                            )
                        )}
                    </td>
                    <td className="delivery-col--actions delivery-col--mobile-only table-actions">
                        <button
                            className="delivery-expand-btn"
                            onClick={() => toggleRow(`${item.rental.id}-${index}`)}
                            title={expandedRows.has(`${item.rental.id}-${index}`) ? 'Recolher itens' : 'Ver itens'}
                        >
                            {expandedRows.has(`${item.rental.id}-${index}`) ? '▲' : '▼'}
                        </button>
                        <TableRowActions actions={buildDeliveryRowActions(item, index)} />
                    </td>
                </tr>
                {expandedRows.has(`${item.rental.id}-${index}`) && (
                    <tr className="delivery-items-expanded-row" style={{backgroundColor: getBackgroundColor(item)}}>
                        <td colSpan={11} className="delivery-items-expanded-cell">
                            {item.rentalItems.map((ri, itemIndex) => (
                                <div key={itemIndex} className="delivery-items-expanded-item">
                                    <b>Item {itemIndex + 1}:</b> {ri.product.name} — Qtd: {ri.quantity}
                                </div>
                            ))}
                        </td>
                    </tr>
                )}
                    </React.Fragment>
                ))}
                </tbody>
                {products.length === 0 && (
                    <tfoot>
                    <tr>
                        <td colSpan={11}>Nenhum item encontrado.</td>
                    </tr>
                    </tfoot>)}
            </table>
            </div>
            </ListPageLayout>
            </div>
        </>
    );
};

export default ProductRentedListToDeliverReturn;
